<a mat-button href="/wiki" target="_blank">{{'help.wiki.title.fullLabel' | translate}}
    <mat-icon>open_in_new</mat-icon></a>
